import Repository from '../Repository';
const resource = '/dp/recipe';

export default {
  getList() {
    return Repository.get(`${resource}`);
  },
  getById(id) {
    return Repository.get(`${resource}/${id}`);
  }
};
